import { styled } from '@mui/material/styles'

import { ReactQueryDevtools as ReactQueryDevtools_ } from 'react-query/devtools'

export const ReactQueryDevtools = styled(ReactQueryDevtools_)`
  & .ReactQueryDevtoolsToggleButton {
    left: 20px;
  }
`
